import { render, staticRenderFns } from "./AmazonAlexaSettingsCard.vue?vue&type=template&id=db240594"
import script from "./AmazonAlexaSettingsCard.vue?vue&type=script&lang=ts"
export * from "./AmazonAlexaSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports